module.exports = __webpack_public_path__ + "static/media/blockchain.618c0ad1.jpeg";